// extracted by mini-css-extract-plugin
export default {"root":"ContextMenu_root__I6Lpb","container":"ContextMenu_container__koPoN"};